"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileCacheExpire = exports.HashtagRegex = exports.DefaultConnectTimeout = void 0;
/**
 * Websocket re-connect timeout
 */
exports.DefaultConnectTimeout = 2000;
/**
 * Hashtag regex
 */
// eslint-disable-next-line no-useless-escape
exports.HashtagRegex = /(#[^\s!@#$%^&*()=+.\/,\[{\]};:'"?><]+)/g;
/**
 * How long profile cache should be considered valid for
 */
exports.ProfileCacheExpire = 1000 * 60 * 60 * 6;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29uc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDVSxRQUFBLHFCQUFxQixHQUFHLElBQUksQ0FBQztBQUUxQzs7R0FFRztBQUNILDZDQUE2QztBQUNoQyxRQUFBLFlBQVksR0FBRyx5Q0FBeUMsQ0FBQztBQUd0RTs7R0FFRztBQUNVLFFBQUEsa0JBQWtCLEdBQUcsSUFBSyxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDIn0=